import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addRealisation } from "../../redux/actions/serviceActions";
import "./styles.css";

export default function FormRealisationModal({ serviceIndex, onClose }) {
  const dispatch = useDispatch();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [photos, setPhotos] = useState([]);

  const handlePhotoUpload = (e) => {
    const files = Array.from(e.target.files);
    files.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result;
        const photo = {
          id: Date.now().toString() + Math.random(),
          name: file.name,
          base64,
        };
        setPhotos((prev) => [...prev, photo]);
      };
      reader.readAsDataURL(file);
    });
    e.target.value = null;
  };

  const removePhoto = (id) => {
    setPhotos((prev) => prev.filter((photo) => photo.id !== id));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!title.trim()) {
      alert("Le titre est requis.");
      return;
    }

    const realisation = {
      title,
      description,
      photos,
    };

    dispatch(addRealisation(serviceIndex, realisation));

    if (onClose) onClose();
  };

  return (
    <div className="modalOverlay">
      <div className="modalContent background-primary">
        <h2>Ajouter une réalisation</h2>
        <form onSubmit={handleSubmit}>
          {/* Titre */}
          <div className="input-form">
            <label>Titre</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </div>

          {/* Description */}
          <div className="input-form">
            <label>Description</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={5}
            />
          </div>

          {/* Upload Photos */}
          <div className="modal-input-form">
            <label>Photos</label>
            <input
              style={{ margin: "auto" }}
              type="file"
              accept="image/*"
              multiple
              onChange={handlePhotoUpload}
            />
            <div className="photo-preview-grid">
              {photos.map((photo) => (
                <div key={photo.id} className="photo-preview-item">
                  <img src={photo.base64} alt="Preview" />
                  <button
                    type="button"
                    onClick={() => removePhoto(photo.id)}
                    className="remove-photo-btn"
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Actions */}
          <div className="modal-input-form">
            <button type="submit">Ajouter</button>
            <button type="button" onClick={onClose}>
              Annuler
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
